/* BOSPHOR – sokak animasyonları (hero, görünür olunca belirme, eğilen kartlar, manifesto, kod kopyalama) */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // görünür olunca belir
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px' });
  const watch = root => root.querySelectorAll('[data-reveal]').forEach((el, i) => {
    if (!el.style.transitionDelay) el.style.transitionDelay = ((+el.dataset.delay || 0) + (el.dataset.stagger ? i * 0.07 : 0)) + 's';
    io.observe(el);
  });

  // HERO: aç + paralaks
  function hero(sh) {
    const go = () => { sh.classList.add('is-go', 'is-shake'); };
    const imgs = [...sh.querySelectorAll('.sh-model')];
    let left = imgs.length;
    const done = () => { if (--left <= 0) go(); };
    imgs.forEach(im => im.complete ? done() : (im.addEventListener('load', done), im.addEventListener('error', done)));
    setTimeout(go, 1600);
    if (!imgs.length) go();
    // ana mankenin genişliğine göre ortala
    const m1 = sh.querySelector('.sh-model--1');
    const fix = () => { if (m1 && m1.offsetWidth) sh.style.setProperty('--w1', (m1.offsetWidth / 2) + 'px'); };
    m1 && (m1.complete ? fix() : m1.addEventListener('load', fix)); addEventListener('resize', fix);
    if (reduce) return;
    const layers = [...sh.querySelectorAll('[data-depth]')];
    let mx = 0, my = 0, tx = 0, ty = 0, sy = 0;
    sh.addEventListener('pointermove', e => { const r = sh.getBoundingClientRect(); mx = (e.clientX - r.left) / r.width - .5; my = (e.clientY - r.top) / r.height - .5; });
    sh.addEventListener('pointerleave', () => { mx = my = 0; });
    const tick = () => {
      const r = sh.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) {
        tx += (mx - tx) * .08; ty += (my - ty) * .08; sy = Math.max(0, -r.top);
        layers.forEach(l => {
          const d = +l.dataset.depth;
          l.style.transform = 'translate3d(' + (tx * d * 40).toFixed(2) + 'px,' + (ty * d * 24 + sy * d * .35).toFixed(2) + 'px,0)';
        });
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  // eğilen ürün kartları
  function tilt(card) {
    if (reduce || matchMedia('(hover: none)').matches) return;
    const inner = card.querySelector('.sp-in'); if (!inner) return;
    card.addEventListener('pointermove', e => {
      const r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      inner.style.transform = 'rotateY(' + (x * 10).toFixed(2) + 'deg) rotateX(' + (-y * 10).toFixed(2) + 'deg)';
    });
    card.addEventListener('pointerleave', () => { inner.style.transform = ''; });
  }

  // manifesto: kaydırdıkça kelimeler yanar
  function manifesto(sec) {
    const words = [...sec.querySelectorAll('.w')]; if (!words.length) return;
    const upd = () => {
      const r = sec.getBoundingClientRect(), p = Math.min(1, Math.max(0, (innerHeight * .85 - r.top) / (r.height * .9)));
      const n = Math.round(p * words.length);
      words.forEach((w, i) => w.classList.toggle('on', i < n));
    };
    addEventListener('scroll', upd, { passive: true }); upd();
  }

  // indirim kodunu kopyala
  function copy(btn) {
    btn.addEventListener('click', async () => {
      const code = btn.dataset.code;
      try { await navigator.clipboard.writeText(code); } catch (e) {
        const t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); document.execCommand('copy'); t.remove();
      }
      const old = btn.textContent; btn.textContent = 'KOPYALANDI ✓'; setTimeout(() => { btn.textContent = old; }, 1800);
    });
  }

  const init = root => {
    watch(root);
    root.querySelectorAll('.sh').forEach(hero);
    root.querySelectorAll('.sp').forEach(tilt);
    root.querySelectorAll('.sm').forEach(manifesto);
    root.querySelectorAll('[data-copy]').forEach(copy);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  // tema düzenleyicide bölüm yeniden yüklenince
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
